import React from 'react';
import { get } from 'lodash';
import Typography from '@material-ui/core/Typography';

const FullNameField = (props) => {
  const { record, firstNameSource, lastNameSource } = props;

  const name = `${get(record, firstNameSource, '')} ${get(record, lastNameSource, '')}`;

  return <Typography>{name}</Typography>;
};

export default FullNameField;
